module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "person-tab"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "departOut"
  }, [_c('ul', {
    staticClass: "departmentList"
  }, [_c('el-button', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.hideDel),
      expression: "hideDel"
    }],
    staticClass: "el-icon-minus",
    on: {
      "click": function($event) {
        _vm.showDel(1)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "el-icon-plus",
    on: {
      "click": function($event) {
        _vm.openPerson(1)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.departmentArray), function(dep, d) {
    return _c('li', [_c('div', {
      staticClass: "imgOut"
    }, [_c('i', {
      staticClass: "dep el-icon-menu"
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCloseDep),
        expression: "showCloseDep"
      }],
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          _vm.delperson(dep.relationId, d, 'department')
        }
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(dep.userName))])])
  })], 2)]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "personList"
  }, [_c('el-button', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.hideDel),
      expression: "hideDel"
    }],
    staticClass: "el-icon-minus",
    on: {
      "click": function($event) {
        _vm.showDel(0)
      }
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "el-icon-plus",
    on: {
      "click": function($event) {
        _vm.openPerson(0)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.staffArray), function(sta, s) {
    return _c('li', [_c('div', {
      staticClass: "imgOut"
    }, [(sta.userAvatar !== '/images/default.jpg') ? _c('img', {
      attrs: {
        "src": sta.userAvatar
      }
    }) : _c('i', {
      staticClass: "per"
    }, [_vm._v(_vm._s(sta.userName.substr(sta.userName.length - 2)))]), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showClosePer),
        expression: "showClosePer"
      }],
      staticClass: "el-icon-circle-close",
      on: {
        "click": function($event) {
          _vm.delperson(sta.relationId, s, 'user')
        }
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(sta.userName))])])
  })], 2), _vm._v(" "), (_vm.personDialog) ? _c('product-person', {
    attrs: {
      "id": _vm.idArr,
      "type": _vm.type
    },
    on: {
      "closeDialog": _vm.closeDialog,
      "refresh": _vm.refresh
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("负责部门")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "theme"
  }, [_c('i'), _c('span', [_vm._v("负责人")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a2b8212","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detail/product/person-tab.vue
// module id = 1309
// module chunks = 82